import './style.scss'
export default function InfoBlock() {
    return <div className="info-block">
        <div className="info-block__wrapper container">
            <div className="info-block__column" data-aos="fade-up">
                <h2 className="info-block__title title">The Future of Finance Is Digital</h2>
                <div className="info-block__column-wrapper">
                    <span>In today's world, information technology is becoming an integral part of the financial sector. We in our company understand that the future of investments is closely linked to digitalization and innovative solutions. </span>
                    <span>That is why we integrate advanced IT platforms and analytical tools into every stage of our work with clients.</span>
                </div>
            </div>

            <div className="info-block__column" data-aos="fade-up">
                <h3 className="info-block__column-subtitle">
                    Transparency and security
                </h3>

                <span>In today's world, information technology is becoming an integral part of the financial sector. We in our company understand that the future of investments is closely linked to digitalization and innovative solutions.
How it works</span>

                <a href="https://direct.secondwise-limitedcapital.com/" className="button">How it works</a>
            </div>


        </div>
    </div>;
}